import { render, staticRenderFns } from "./otherdetails.vue?vue&type=template&id=6c191ab1&scoped=true&"
import script from "./otherdetails.vue?vue&type=script&lang=js&"
export * from "./otherdetails.vue?vue&type=script&lang=js&"
import style0 from "./otherdetails.vue?vue&type=style&index=0&id=6c191ab1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c191ab1",
  null
  
)

export default component.exports